import { GRAPH_EDGES } from "../data/GraphBuilder/GraphEdges";
import { GRAPH_NODES } from "../data/GraphBuilder/GraphNodes";
export const getGraphNodes = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(GRAPH_NODES);
        }, 1000);
    });
};
export const getGraphEdges = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(GRAPH_EDGES);
        }, 1000);
    });
};
